import React from 'react'
import Select from 'react-select'
import { connect } from 'react-redux'
import { Col, Row, Label, FormGroup, FormFeedback, Input } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { STYLES_REACT_SELECT } from '../../../constants'

const DISPLAY_CENTERS = {
  owner: { displayBrands: false, displayDelegations: false },
  admin: { displayBrands: false, displayDelegations: false },
  brandManager: { displayBrands: true, displayDelegations: false },
  delegationManager: { displayBrands: true, displayDelegations: true },
  operator: { displayBrands: true, displayDelegations: true },
  comunityManager: { displayBrands: false, displayDelegations: false },
  default: { displayBrands: true, displayDelegations: true },
}

class SelectBrandsAndDelegations extends React.Component {
  constructor(props) {
    super(props)

    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(values, name) {
    const { rawObject, isMulti } = this.props

    // Return all object
    if (rawObject) return this.props.onChange({ [name]: values || [] })

    const newValues = (values && (!isMulti ? [values.value] : values.map((v) => v.value))) || []

    return this.props.onChange({ [name]: newValues })
  }

  render() {
    const { className = '', isMulti, currentBrands, currentDelegations, brands, delegations } = this.props

    const brandOptions = Object.values(brands).map((b) => ({
      value: b._id,
      label: b.name,
      data: b,
    }))
    const selectedBrandsArray = currentBrands.map((b) => ({
      value: brands[b]._id,
      label: brands[b].name,
      data: brands[b] || {},
    }))
    const selectedBrandOptions = !isMulti ? selectedBrandsArray[0] : selectedBrandsArray

    const delegationsOptions =
      currentBrands.length > 0
        ? Object.values(delegations)
          .filter((d) => currentBrands.includes(d.brand))
          .map((d) => ({ value: d._id, label: d.name, data: d }))
        : []
    const selectedDelegationsArray = delegationsOptions.some((d) => currentDelegations.includes(d.value))
      ? currentDelegations.map((d) => ({
        value: delegations[d]._id,
        label: delegations[d].name,
        data: delegations[d] || {},
      }))
      : []
    const selectedDelegationOptions = !isMulti ? selectedDelegationsArray[0] || '' : selectedDelegationsArray

    const { displayBrands, displayDelegations } = DISPLAY_CENTERS[this.props.operatorRole] || DISPLAY_CENTERS.default

    return (
      <>
        {displayBrands && (
          <Row className={className}>
            <Col xs={12}>
              <FormGroup>
                <Label for='dashuser.brands'>{I18n.t('dashboard_brands')}</Label>
                <Select
                  isDisabled={this.props.isDisabled}
                  onChange={(values) => this.handleChange(values, 'brands')}
                  isMulti={isMulti}
                  options={brandOptions}
                  value={selectedBrandOptions || ''}
                  styles={STYLES_REACT_SELECT}
                />
                <Input hidden={true} invalid={this.props.errors && this.props.errors.brands} />

                <FormFeedback>{this.props.errors && this.props.errors.brands ? I18n.t('dashboard_errors_required-field') : ''}</FormFeedback>
              </FormGroup>
            </Col>
          </Row>
        )}
        {displayDelegations && (
          <Row>
            <Col xs={12} className='mt-3'>
              <FormGroup>
                <Label for='dashuser.delegations'>{I18n.t('dashboard_delegations')}</Label>
                <Select
                  isDisabled={this.props.isDisabled}
                  onChange={(values) => this.handleChange(values, 'delegations')}
                  isMulti={isMulti}
                  options={delegationsOptions}
                  value={selectedDelegationOptions || ''}
                  styles={STYLES_REACT_SELECT}
                />
                <Input hidden={true} invalid={this.props.errors && this.props.errors.delegations} />
                <FormFeedback>{this.props.errors && this.props.errors.delegations ? I18n.t('dashboard_errors_required-field') : ''}</FormFeedback>
              </FormGroup>
            </Col>
          </Row>
        )}
      </>
    )
  }
}

export default connect((state) => ({
  brands: state.brands,
  delegations: state.delegations,
}))(SelectBrandsAndDelegations)
